import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, styled } from '@mui/material';

import { homeBackgroundImage } from '@frontend/assets';
import { routes } from '@frontend/router/routes';

import { HotelSearchBar } from './Search/HotelSearchBar';
import { useHotelSearch } from './Search/HotelSearchContext';
import { appendHotelAvailabilityQueryParamsToUrl } from './Search/helpers';

const SearchLayout = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  background,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const SearchBarContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1156px',
  display: 'flex',
  backgroundColor: theme.palette.common.white,
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  margin: theme.spacing(3),
  position: 'relative',
  bottom: '-90px',
  boxShadow: theme.shadows[10],
  borderRadius: theme.spacing(2),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

const background = `url("${homeBackgroundImage}")`;

export const HotelAvailabilitySearchLayout = () => {
  const { t } = useTranslation();
  const { searchData } = useHotelSearch();
  const navigate = useNavigate();

  const handleSubmitSearch = () => {
    const params = appendHotelAvailabilityQueryParamsToUrl(searchData);
    navigate(`${routes.hotels.availability}?${params?.toString()}`);
  };

  const { location, from, to, rooms } = searchData;

  return (
    <SearchLayout>
      <SearchBarContainer>
        <HotelSearchBar />
        <Box display="flex" justifyContent="end" width="100%">
          <Button variant="contained" onClick={handleSubmitSearch} disabled={!location || !from || !to || !rooms}>
            {t('hotels.searcher.search')}
          </Button>
        </Box>
      </SearchBarContainer>
    </SearchLayout>
  );
};
